module.exports = __webpack_public_path__ + "assets/299abd6b202318011080716edf9e1c9d.mp3";